export default __webpack_public_path__ + "static/media/basket-icon.c3ef9a8e.svg";